var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderHeroIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "170px",
    height: "163px",
    viewBox: "0 0 170 163",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-4.3%",
    y: "-3.2%",
    width: "108.6%",
    height: "109.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "path-2",
    points: "0 0.201822917 161.997563 0.201822917 161.997563 155 0 155"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    transform: "translate(4.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.997563,155 C158.992932,152.236641 156.011596,149.448255 152.980188,146.715035 C139.721358,134.759852 126.445927,122.8227 113.180671,110.874514 C104.81558,103.340061 96.4579864,95.7969965 88.0936988,88.261467 C87.8992988,88.0862847 87.6633947,87.9576563 87.3806311,87.7614844 C89.7833187,85.5955208 92.0175798,83.5813281 94.3439534,81.4839844 C114.253352,99.4263108 134.12071,117.330425 154.150337,135.381198 L154.150337,10.54 L7.68091537,10.54 L7.68091537,135.361016 C8.21350711,134.907856 8.64033025,134.562335 9.04787405,134.195286 C19.7039931,124.595243 30.3579699,114.992509 41.0130179,105.39112 C53.6827567,93.9749392 66.3530311,82.5592969 79.0227699,71.1431163 C81.8113121,68.6305556 84.6076195,66.1263368 87.3859864,63.602474 C94.4293716,57.2044184 101.449729,50.7807986 108.506234,44.3980816 C116.85633,36.8450608 125.236148,29.3259462 133.597491,21.785842 C134.341352,21.1152517 135.105831,20.7503559 136.182529,20.7721528 C140.160231,20.8526128 144.140879,20.8041753 148.120724,20.8041753 C148.179365,20.8900174 148.237739,20.9761285 148.29638,21.0619705 C98.8767402,65.6180122 49.4571005,110.173785 -2.67768595e-05,154.763733 L-2.67768595e-05,0.215277778 L1.33774512,0.215277778 C54.4895435,0.215277778 107.641342,0.215277778 160.79314,0.214739583 C161.194525,0.214739583 161.596178,0.206397569 161.997563,0.201822917 L161.997563,155 Z",
    id: "Fill-1",
    fill: "#FEFEFE",
    mask: "url(#mask-3)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.1174177,70 C49.0990416,53.7196539 31.1443033,37.4969759 13,21.1031979 C13.523663,21.0561386 13.771203,21.0147917 14.018743,21.0145196 C18.0276503,21.0107114 22.0379059,20.9644681 26.0449257,21.0599468 C26.7069199,21.075724 27.4541239,21.6048012 27.9936963,22.0879072 C33.556335,27.0693939 39.0841887,32.0903233 44.6222891,37.099828 C51.587924,43.4000635 58.5551769,49.6986669 65.5189242,56.0013506 C68.2224491,58.4481628 70.9181542,60.9039517 73.6160164,63.3575644 C73.7370899,63.4674601 73.8422539,63.5953091 74,63.7626009 C71.7217153,65.8274983 69.4717441,67.8665538 67.1174177,70",
    id: "Fill-4",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1023549,116 C15.0562699,115.526777 15.0093949,115.266872 15.0091316,115.006967 C15.0043914,111.468012 14.9806906,107.928511 15.0357292,104.390373 C15.0433661,103.893993 15.3259328,103.266571 15.6838155,102.931746 C22.5583763,96.5038692 29.4634847,90.1116817 36.3609563,83.7102315 C41.3981751,79.0352139 46.4327605,74.3577445 51.470506,69.6835442 C51.7101479,69.4609633 51.9679604,69.2593599 52.2737012,69 C54.5102706,71.0727001 56.7052319,73.107259 59,75.2336291 C44.372104,88.8181513 29.8024068,102.348458 15.1023549,116",
    id: "Fill-6",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9185664,57 C77.5841007,54.9030092 75.3306835,52.8783098 73,50.7845559 C74.8530379,49.1159187 76.6439386,47.496375 78.4424039,45.8851934 C87.431218,37.8322523 96.4265161,29.7865943 105.401822,21.7188173 C105.969972,21.2079219 106.519751,20.9921266 107.289711,21.000219 C111.273513,21.0425688 115.258125,21.0228775 119.242467,21.0263841 C119.402673,21.0263841 119.562879,21.0441872 120,21.0703524 C106.550549,33.1268358 93.276973,45.0252491 79.9185664,57",
    id: "Fill-8",
    fill: "#FEFEFE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderHeroIcon);
export default __webpack_public_path__ + "static/media/header-hero-icon.f3f9a0d47d5e0747cac9a25122e63117.svg";
export { ForwardRef as ReactComponent };